import Const from 'constants';
import {getModesConfig} from 'helpers/modes-config';

const defaultState = {
    data: {},
    getConfig(mode) {
        const modes = this.all();

        return modes[mode] ?? {};
    },
    all(params = {asArr: false}) {
        return params.asArr ? Object.values(this.data) : {...this.data};
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.MODES_CONFIG_INIT) {
        state = {...state};

        const {sportConfig} = action;
        state.data = getModesConfig(sportConfig);
    } else if (inArray(action.type, [Const.FILTER_BY_SPORT, Const.FILTER_BY_SITE, Const.FILTER_BY_GAME_TYPE])) {
        state = {...defaultState};
    }

    return state;
}
